import { expected } from '@aloft/toolkit-shared';
import { Flex, Table, Tbody, Td, Th, Thead, Tr, Typography } from '@aloft/toolkit-sui';

import { AdjustmentSettingsHelperText } from '../../../components/AdjustmentSettingsHelperText.tsx';
import { MarketAdjustmentsTableDisplay } from '../../../redux/features/selectors/calculatedMarketAdjustmentSelectors/selectMarketAdjustmentsDisplay.ts';

export const CommentaryDateOfSaleTable = ({
  data,
  helperText,
}: {
  data: MarketAdjustmentsTableDisplay[][];
  helperText?: string;
}) => {
  const [headers, ...rows] = data;

  return (
    <Flex flexDirection="column" gap={1} overflowX="auto">
      <Table className="commentary-table">
        <Thead>
          <Tr>
            {expected(headers).map(({ value: header }) => (
              <Th key={header}>
                <Typography variant="h5">{header}</Typography>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {rows.map((row, rowIndex) => (
            <Tr key={`${rowIndex}${row[0]?.value}`}>
              {row.map(({ value, isProjection }, cellIndex) => (
                <Td
                  className={isProjection ? 'projection-text' : undefined}
                  key={`${rowIndex}${cellIndex}${value}`}
                >
                  {value}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
      {helperText && <AdjustmentSettingsHelperText helperText={helperText} />}
    </Flex>
  );
};
